<div class="main-content side-content pt-0 ml-0">
  <div class="main-container container-fluid">
    <div class="inner-body">
      <div class="row row-sm">
        <div class="col-lg-12">
          <div class="card custom-card">
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-md-4">
                  <div class="d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-45px pb-2">
                    <div class="ml-2">
                      <h3 class="main-content-label mb-1"><b>Optional Subject Selection</b></h3>
                      <p class="text-muted card-sub-title mb-0">
                        Select a student to manage optional subjects
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <form [formGroup]="studentFilterForm">
                <div class="row mt-3">
                  <div class="col-md-3">
                    <mat-form-field appearance="outline" class="example-full-width">
                      <mat-label>Course</mat-label>
                      <mat-select formControlName="CoCode"
                        (selectionChange)="onCourseChange($event.value); getStudentData()">
                        <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCode">
                          {{item.CoCode}} - {{item.CoName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-3">
                    <mat-form-field appearance="outline" class="example-full-width">
                      <mat-label>Exam</mat-label>
                      <mat-select formControlName="exam" (selectionChange)="getStudentData()">
                        <mat-option *ngFor="let item of filteredExamList" [value]="item.EmId">
                          {{ item.EmCoCode ? item.EmCoCode + ' - ' : '' }}{{item.EmName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="example-full-width">
                      <mat-label>Search (PRN / Roll No / Name)</mat-label>
                      <mat-icon matSuffix class="search-icon">search</mat-icon>
                      <input matInput formControlName="SearchString" placeholder="Enter PRN or Name"
                        (keydown.enter)="onSearchEnter($event)">
                    </mat-form-field>
                  </div>
                </div>
              </form>

              <hr class="mt-2">

              <div class="table-responsive">
                <table class="table table-bordered text-nowrap text-left">
                  <thead>
                    <tr>
                      <th width="15%">Rg. No.</th>
                      <th width="30%">Name</th>
                      <!-- <th width="20%">PRN</th>-->
                      <th width="20%">Course</th> 
                      <th width="15%" class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let student of studentDataList">
                      <td>{{student.StuRgNo}}</td>
                      <td>{{student.FullName}}</td>
                      <!-- <td>{{student.PrnNo}}</td>-->
                      <td>{{student.CoName}}</td> 
                     <td class="text-center">
                        <a style="color: blue; cursor: pointer;"
                          (click)="openOptionalSubjectPopup(student)">
                          Select Subjects
                        </a>
                      </td>
                    </tr>
                    <tr *ngIf="studentDataList.length === 0">
                      <td colspan="5" class="text-center">No students found</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                (page)="onPageChange($event)">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>